import { render, staticRenderFns } from "./VideoPreview.vue?vue&type=template&id=767df1d4&"
import script from "./VideoPreview.vue?vue&type=script&lang=js&"
export * from "./VideoPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports